<template>
<div id="app" class="legal-page page-template-default no-sidebar separate-containers">
  <HeadNav selectedLanguage="en" :page="pageKey" :gotodownload="goToDownload" :apk="apk" />

  <main class="legal-main">
    <article class="legal-shell">
      <header>
        <p class="eyebrow">{{ current.eyebrow }}</p>
        <h1>{{ current.title }}</h1>
        <p v-if="current.updated" class="updated">Effective Date: {{ current.updated }}</p>
      </header>

      <section v-for="section in current.sections" :key="section.heading" class="legal-section">
        <h2>{{ section.heading }}</h2>
        <p v-for="paragraph in section.paragraphs" :key="paragraph">{{ paragraph }}</p>
        <ul v-if="section.items">
          <li v-for="item in section.items" :key="item">{{ item }}</li>
        </ul>
      </section>
    </article>
  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

const DEFAULT_DOMAIN = 'gbwasap.org';
const DEFAULT_APP_NAME = 'GB_gbwasap.org';

const pages = {
  privacy: {
    title: 'Privacy Policy',
    eyebrow: 'Site policy',
    updated: 'September 2026',
    sections: [
      {
        heading: 'Information We Collect',
        paragraphs: [
          'We may collect non-personal information such as browser type, device type, approximate region, referring pages, and pages visited. This helps us understand how visitors use gbwasap.org.',
          'If you contact us by email, we may receive your email address and the information you choose to include in your message.',
        ],
      },
      {
        heading: 'How We Use Information',
        paragraphs: [
          'We use information to operate the website, improve content quality, respond to questions, detect abuse, and maintain basic site security.',
          'We do not claim to be the developer of GB WhatsApp, WhatsApp, or any related modified client. Our site shares informational content and download guidance.',
        ],
      },
      {
        heading: 'Cookies and Analytics',
        paragraphs: [
          'The site may use cookies or similar technologies for analytics, performance measurement, and basic functionality. You can disable cookies in your browser settings.',
        ],
      },
      {
        heading: 'Third-Party Links',
        paragraphs: [
          'Our pages may reference third-party websites, apps, or services. We are not responsible for the content, security, privacy practices, or download files provided by third parties.',
        ],
      },
      {
        heading: 'Contact',
        paragraphs: ['For privacy questions, contact us at support@gbwasap.org.'],
      },
    ],
  },
  disclaimer: {
    title: 'Disclaimer',
    eyebrow: 'Important notice',
    updated: 'September 2026',
    sections: [
      {
        heading: 'Informational Purpose',
        paragraphs: [
          'gbwasap.org is an independent information website. We share guides, version notes, safety reminders, and APK download information for visitors who want to learn about GB WhatsApp.',
          'We are not the developer, owner, maintainer, or official distributor of GB WhatsApp, WhatsApp, Meta, or any modified WhatsApp client.',
        ],
      },
      {
        heading: 'No Official Affiliation',
        paragraphs: [
          'WhatsApp is a trademark of its respective owner. GB WhatsApp is a third-party modified client and is not an official WhatsApp application.',
          'References to app names, logos, or services are for identification and informational purposes only.',
        ],
      },
      {
        heading: 'APK and Account Risk',
        paragraphs: [
          'Installing any third-party APK can involve file safety, privacy, compatibility, and account-access risks. Users should review APK information, back up important data, and make their own decision before installing.',
          'Claims such as "anti-ban", "100% safe", or "guaranteed secure" should not be treated as guarantees.',
        ],
      },
      {
        heading: 'Use at Your Own Discretion',
        paragraphs: [
          'The information on this website is provided without warranties. We are not responsible for losses, device issues, data loss, account restrictions, or other consequences related to third-party apps or downloads.',
        ],
      },
    ],
  },
  about: {
    title: 'About Us',
    eyebrow: 'About gbwasap.org',
    updated: '',
    sections: [
      {
        heading: 'Who We Are',
        paragraphs: [
          'gbwasap.org is an independent website focused on GB WhatsApp information, Android APK download guidance, installation help, troubleshooting, and safety reminders.',
          'We are not developers of GB WhatsApp and we are not affiliated with WhatsApp or Meta. Our goal is to help readers understand the features and trade-offs before they use a third-party modified app.',
        ],
      },
      {
        heading: 'What We Publish',
        paragraphs: [
          'We publish version information, feature explanations, setup steps, old-version notes, alternatives, and practical warnings about privacy, account restrictions, and backup compatibility.',
        ],
      },
      {
        heading: 'Editorial Approach',
        paragraphs: [
          'We avoid presenting modified clients as official apps. We also encourage users to back up important data and consider the official WhatsApp app when account stability and official support matter most.',
        ],
      },
    ],
  },
  contact: {
    title: 'Contact Us',
    eyebrow: 'Support',
    updated: '',
    sections: [
      {
        heading: 'Email',
        paragraphs: ['For website questions, correction requests, or general feedback, contact us at support@gbwasap.org.'],
      },
      {
        heading: 'Before You Contact Us',
        paragraphs: [
          'Please remember that we are an independent information website. We are not the developer of GB WhatsApp and cannot provide official WhatsApp account support, verification codes, or account-ban reviews.',
        ],
      },
    ],
  },
};

export default {
  name: 'LegalPage',
  components: {
    HeadNav,
  },
  data() {
    return {
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  computed: {
    pageKey() {
      return this.$route.meta.legalKey || 'privacy';
    },
    current() {
      return pages[this.pageKey] || pages.privacy;
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          this.apk = res.code == 200 ? res.data.apk : process.env.VUE_APP_GBLINK;
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || DEFAULT_DOMAIN,
          appName: appname || DEFAULT_APP_NAME,
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goToDownload() {
      this.$router.push({
        name: 'en-download',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.legal-main {
  min-height: 72vh;
  background: #f6f8f7;
  padding: 42px 0 64px;
}

.legal-shell {
  width: min(860px, calc(100% - 32px));
  margin: 0 auto;
  padding: 34px;
  border: 1px solid #dbe8e1;
  border-radius: 8px;
  background: #fff;
}

.eyebrow {
  margin: 0 0 8px;
  color: #107b59;
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
}

h1 {
  margin: 0 0 10px;
  color: #10261d;
  font-size: 40px;
  font-weight: 800;
  line-height: 1.14;
  text-align: center;
}

.updated {
  color: #6c7f77;
}

.legal-section {
  padding-top: 24px;
  border-top: 1px solid #e2ece7;
}

h2 {
  margin: 0 0 12px;
  color: #15372a;
  font-size: 24px;
  font-weight: 800;
  text-align: center;
}

p,
li {
  color: #40544c;
  font-size: 16px;
  line-height: 1.72;
}

ul {
  margin: 0 0 16px 20px !important;
}

@media (max-width: 620px) {
  .legal-main {
    padding: 24px 0 44px;
  }

  .legal-shell {
    width: min(100% - 24px, 860px);
    padding: 22px;
  }

  h1 {
    font-size: 32px !important;
  }
}
</style>
